import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Container, Row, Col } from 'reactstrap'
import { CompanyDetails } from './CompanyDetails'
import { ContactsSection } from './ContactsSection'
import { CompanyTabs } from './CompanyTabs'
import { LinkedCompanySection } from './LinkedCompanySection'
import s from './Company.scss'
import { makeGetRequest } from 'utils/api'
import { CompanySidebar } from './CompanySidebar'

const Company = ({ company, pipeline, stats }) => {
  const sidebar = useSelector(state => state.sidebar)
  const isSidebarOpen = sidebar.companySidebar.isOpen

  const { id, name, parent } = company
  const [parentCompany, setParentCompany] = useState(null)

  useEffect(() => {
    ;(async () => {
      if (!parent?.id) return false
      const parentCompany = await makeGetRequest(`/v1/companies/${parent.id}`)
      setParentCompany({
        value: parentCompany.id,
        label: parentCompany.name
      })
    })()
  }, [parent])

  return (
    <section>
      <Container className={s.container}>
        <Row>
          <Col lg={isSidebarOpen ? '2' : '3'} className={s.left}>
            <ContactsSection companyId={id} companyName={name} />
            {(company.parent || company.subsidiaryCompanies) && (
              <LinkedCompanySection
                parent={company.parent}
                subsidiaryCompanies={company.subsidiaryCompanies}
              />
            )}
          </Col>
          <Col lg={isSidebarOpen ? '7' : '9'} className={s.main}>
            <CompanyDetails parentCompany={parentCompany} company={company} />
            <CompanyTabs companyId={id} companyName={name} />
          </Col>
          {isSidebarOpen ? (
            <Col lg="3" className={s.sidebar}>
              <CompanySidebar company={company} pipeline={pipeline} stats={stats} />
            </Col>
          ) : (
            <div className={s.sidebarCollapsed}>
              <CompanySidebar company={company} pipeline={pipeline} stats={stats} />
            </div>
          )}
        </Row>
      </Container>
    </section>
  )
}

export default Company
